class CouponDrawer extends HTMLElement {
  constructor() {
    super();
    this.authorization_token = null;
    this.currentCoupon = null;
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.applyBtns = this.querySelectorAll(".coupon__apply_btnn");
    this.input = this.querySelector("#discount-code-input");
    this.clearBtn = this.querySelector("#clear-discount-btn");
    this.discountCodeError = this.querySelector("#discount-code-error");
    this.discountCodeWrapper = this.querySelector("#applied-discount-code .applied-discount-code-wrapper");
    this.discountCodeValue = this.querySelector("#applied-discount-code .applied-discount-code-value");
    this.totalCartSelector = this.querySelector(".totals__total-value");
    this.appliedText = this.querySelector(".applied_text");

    // Load stored discount if available
    this.loadStoredDiscount();
    this.addEventListeners();
  }

  addEventListeners() {
    this.applyBtns.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const discountCode = this.input.value.trim();
        if (discountCode) {
          await this.applyDiscountToCart(discountCode);
        } else {
          this.displayError("Please enter a discount code.");
        }
      });
    });

    if (this.clearBtn) {
      this.clearBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.clearDiscount();
      });
    }

    if (this.input) {
      this.input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") e.preventDefault();
      });
    }

    // Add event listener for coupon copy buttons
    document.querySelectorAll(".coupon__apply_btn_copy").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const couponCode = btn.dataset.coupon;
        if (!couponCode) return;
        
        // Set coupon code in input
        this.input.value = couponCode;
        e.target.parentNode.classList.toggle("active");
        this.spinner = e.target.parentNode.querySelector(".loading__spinner");
        if (e.target.parentNode.classList.contains("active")) {
            if (this.spinner) {
                this.spinner.classList.remove("hidden");
            }
        }
        setTimeout(()=>{
          this.spinner.classList.add("hidden");
        },1800);
        
        // Trigger click on Apply button
        const applyButton = this.querySelector(".coupon__apply_btnn");
        if (applyButton) {
          applyButton.click();
        }
      });
    });
  }

async applyDiscountToCart(discountCode) {
  try {
    this.appliedText.classList.remove("hidden"); // Show "Coupon Applying"

    const cartResponse = await fetch("/cart.js");
    const cartData = await cartResponse.json();

    if (!cartData.token) {
      this.displayError("No active cart found.");
      return;
    }

    const cartId = `gid://shopify/Cart/${cartData.token}`;

    const query = `
      mutation {
        cartDiscountCodesUpdate(cartId: "${cartId}", discountCodes: ["${discountCode}"]) {
          cart {
            id
            checkoutUrl
            discountCodes {
              code
              applicable
            }
          }
          userErrors {
            field
            message
          }
        }
      }
    `;

    const response = await fetch(SHOPIFY_STORE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({ query }),
    });

    const data = await response.json();

    const userErrors = data?.data?.cartDiscountCodesUpdate?.userErrors || [];
    if (data.errors || userErrors.length > 0) {
      this.displayError("Failed to apply discount. Please try again.");
      return;
    }

    const updatedCart = data.data.cartDiscountCodesUpdate.cart;
    const discount = updatedCart.discountCodes?.[0];

    if (discount?.applicable) {
      localStorage.setItem("discountCode", JSON.stringify({ code: discountCode }));
      this.updateUI(discountCode);
      cartDrawerUpdatem(); // Refresh cart drawer
    } else {
      this.displayError("Discount code is invalid or not applicable.");
    }

    const isApplicable = discount?.applicable;
    const wrapper = this.querySelector(".applied-discount-code-wrapper");

    if (wrapper) {
      wrapper.style.display = isApplicable ? "inline" : "none";
    }

    const drawerWrapper = document.querySelector("cart-drawer .applied-discount-code-wrapper");
    if (drawerWrapper) {
      drawerWrapper.style.display = isApplicable ? "inline" : "none";
    }

  } catch (error) {
    console.error("Error applying discount:", error);
    this.displayError("Something went wrong. Please try again.");
  }
}

clearDiscount() {
  localStorage.removeItem("discountCode");
  this.input.value = "";
  this.discountCodeWrapper.classList.add("hidden");
  this.discountCodeValue.textContent = "";

  const drawerValue = document.querySelector("cart-drawer .applied-discount-code-value");
  const drawerWrapper = document.querySelector("cart-drawer .applied-discount-code-wrapper");

  if (drawerValue) drawerValue.innerHTML = "";
  if (drawerWrapper) drawerWrapper.style.display = "none";

  this.displayError(""); // Clear any error message
}

loadStoredDiscount() {
  const storedDiscount = localStorage.getItem("discountCode");
  if (storedDiscount) {
    const { code } = JSON.parse(storedDiscount);
    this.updateUI(code);
  }
}

  updateUI(discountCode) {
    this.discountCodeWrapper.classList.remove("hidden");
    this.discountCodeValue.textContent = discountCode;
    document.querySelector(".cart-sidebar-discount .applied-discount-code-wrapper").style.display = 'inline';
    document.querySelector(".cart-sidebar-discount .applied-discount-code-value").innerHTML = discountCode;
    this.discountCodeWrapper.style.display = "inline";
    this.discountCodeError.textContent = ""; // Clear any error message
  }

  displayError(message) {
    this.discountCodeError.textContent = message;
  }
}

customElements.define("coupon-drawer", CouponDrawer);

// Function to update cart drawer
function cartDrawerUpdatem() {
  fetch(`${window.Shopify.routes.root}cart?section_id=coupon-drawer`)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Failed to fetch cart drawer items: ${response.status}`);
      }
      return response.text();
    })
    .then((responseText) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(responseText, "text/html");
      const updatedSection = html.querySelector("coupon-drawer");
      const currentSection = document.querySelector("coupon-drawer");
      if (updatedSection && currentSection) {
        currentSection.replaceWith(updatedSection);
      } else {
        console.warn("cart-drawer-items section not found in the DOM or response.");
      }
    })
    .catch((error) => {
      console.error("Error reloading cart drawer items:", error);
    });
}



const STOREFRONT_ACCESS_TOKEN = "82ed5287d7ac9acc717b800ad180504e";
const SHOPIFY_STORE_URL = "https://boltnutritions.myshopify.com/api/2024-01/graphql.json";
